const GetOtpBtn = ({
  onClick,
  loading = false,
  timer = 0,
  text = "Get OTP",
  loadingText = "Sending...",
  className = "",
  style = {},
}) => {
  const disabled = loading || timer > 0;

  const formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`get-otp-btn ${className}`}
      style={{
        background: "rgba(111, 230, 184, 0.12)",
        color: "#6FE6B8",
        border: "1px solid rgba(111, 230, 184, 0.35)",
        fontSize: "0.8rem",
        fontWeight: "600",
        padding: "6px 14px",
        borderRadius: "8px",
        cursor: disabled ? "not-allowed" : "pointer",
        whiteSpace: "nowrap",
        flexShrink: 0,
        opacity: disabled ? 0.5 : 1,
        transition: "background 0.25s ease, border-color 0.25s ease, opacity 0.25s ease",
        ...style,
      }}
    >
      {loading ? loadingText : timer > 0 ? formatTimer(timer) : text}
    </button>
  );
};

export default GetOtpBtn;
